@if (showSpinner$ | async) {
  <div class="vault-spinner" (click)="handleClick()">
    <div class="spinner-wrapper">
      <div class="spinner-spinner">
        <i class="fa fa-spinner fa-pulse"></i>
      </div>
      <div class="spinner-message">{{ 'app.processing' | translate }}</div>
    </div>
  </div>
}
